// ─────────────────────────────────────────────────────────────
// PATCH: VariantRadios.toggleBuyButton — re-validate ATC
// ─────────────────────────────────────────────────────────────
(function patchVariantRadiosForFusion() {
    function tryPatch() {
        if (window.fusionATCPatched) return;
        var Cls = (typeof VariantRadios  !== 'undefined') ? VariantRadios
                : (typeof VariantSelects !== 'undefined') ? VariantSelects : null;
        if (!Cls || typeof Cls.prototype.toggleBuyButton !== 'function') return;
        var _orig = Cls.prototype.toggleBuyButton;
        Cls.prototype.toggleBuyButton = function () {
            _orig.apply(this, arguments);
            if (!document.querySelector('#scent-data')) return;
            requestAnimationFrame(function () {
                if (typeof window._fusionValidateATC === 'function') window._fusionValidateATC();
                // Re-apply button text after Shopify overwrites it
                if (typeof window._fusionSyncButtonText === 'function') window._fusionSyncButtonText();
            });
        };
        window.fusionATCPatched = true;
    }
    tryPatch();
    document.addEventListener('DOMContentLoaded', tryPatch);
    var _pn = 0, _pt = setInterval(function () {
        tryPatch(); if (window.fusionATCPatched || ++_pn > 60) clearInterval(_pt);
    }, 100);
})();


// ─────────────────────────────────────────────────────────────
// MAIN FUSION LOGIC
// ─────────────────────────────────────────────────────────────
$(document).ready(function () {

    // LEFT IMAGE → Scent 1
$(document).on('click', '#fusion-slot-1', function () {
    $('.scent-btn[data-fusion-scent="option1"]').trigger('click');
});

// RIGHT IMAGE → Scent 2
$(document).on('click', '#fusion-slot-2', function () {
    $('.scent-btn[data-fusion-scent="option2"]').trigger('click');
});
    
    function _updateConcentrationLabels() {
    var name1 = selectedScent1 ? selectedScent1.title : 'Perfume 1';
    var name2 = selectedScent2 ? selectedScent2.title : 'Perfume 2';

    $('.label-scent1').text(name1);
    $('.label-scent2').text(name2);
}
    if (!$('#scent-data').length) return;

    var scentData      = JSON.parse($('#scent-data').html());
    var requiredScent1 = !!(scentData && scentData.requirements && scentData.requirements.scent1_required);
    var requiredScent2 = !!(scentData && scentData.requirements && scentData.requirements.scent2_required);
    var selectedScent1 = null;
    var selectedScent2 = null;
    var activeScentKey = null;
    var currentProducts = [];

    $('input.scent1-hidden, input.scent2-hidden').attr('name', '').val('');

    // ─────────────────────────────────────────────────────────
    // BOTTLE SLOT IMAGE UPDATE
    // Updates the two bottle image slots independently.
    // No gallery replacement, no split slider.
    // ─────────────────────────────────────────────────────────

    var placeholder1 = window.fusionBottlePlaceholder1 || '';
    var placeholder2 = window.fusionBottlePlaceholder2 || '';
    var hasPlaceholder1 = window.fusionHasBottlePlaceholder1;
    var hasPlaceholder2 = window.fusionHasBottlePlaceholder2;

    /**
     * Set image for a bottle slot.
     * @param {string} slotId    - 'fusion-slot-1' or 'fusion-slot-2'
     * @param {string} imgId     - 'fusion-bottle-img-1' or 'fusion-bottle-img-2'
     * @param {string|null} url  - image URL, or null to restore placeholder
     */
    function _setBottleImage(slotId, imgId, url) {
        var $slot = $('#' + slotId);
        var $img  = $('#' + imgId);

        if (url) {
            $img.attr('src', url).show();
            $slot.find('.fusion-bottle-fallback').hide();
            $slot.addClass('has-scent');
        } else {
            // Restore placeholder
            if (hasPlaceholder1 && imgId === 'fusion-bottle-img-1' && placeholder1) {
                $img.attr('src', placeholder1).show();
                $slot.find('.fusion-bottle-fallback').hide();
            } else if (hasPlaceholder2 && imgId === 'fusion-bottle-img-2' && placeholder2) {
                $img.attr('src', placeholder2).show();
                $slot.find('.fusion-bottle-fallback').hide();
            } else {
                $img.attr('src', '').hide();
                $slot.find('.fusion-bottle-fallback').show();
            }
            $slot.removeClass('has-scent is-personalized');
        }
    }

    /**
     * Main update function — called whenever scent selection changes.
     * Each slot updates independently based on selectedScent1/selectedScent2.
     */
    function _updateProductImg() {
        // Slot 1 — Scent 1 — use main product image first
        if (selectedScent1) {
            var url1 = selectedScent1.image
                    || selectedScent1.bannerImage
                    || '';
            _setBottleImage('fusion-slot-1', 'fusion-bottle-img-1', url1);
        } else {
            _setBottleImage('fusion-slot-1', 'fusion-bottle-img-1', null);
        }

        // Slot 2 — Scent 2 — use main product image first
        if (selectedScent2) {
            var url2 = selectedScent2.image
                    || selectedScent2.bannerImage
                    || '';
            _setBottleImage('fusion-slot-2', 'fusion-bottle-img-2', url2);
        } else {
            _setBottleImage('fusion-slot-2', 'fusion-bottle-img-2', null);
        }
    }

    // ─────────────────────────────────────────────────────────
    // ATC VALIDATION
    // ─────────────────────────────────────────────────────────
    function _canPurchase() {
        if (requiredScent1 && !selectedScent1) return false;
        if (requiredScent2 && !selectedScent2) return false;
        // Sold-out combination, or no bottle size selected
        if (_isSelectionSoldOut()) return false;
        var $sizes = _sizeInputs();
        if ($sizes.length && !$sizes.filter(':checked').length) return false;
        try {
            var vs = document.querySelector(
                'variant-radios script[type="application/json"],' +
                'variant-selects script[type="application/json"]'
            );
            if (vs) {
                var vlist = JSON.parse(vs.textContent);
                var cid   = Number($('form[action="/cart/add"] input[name="id"]').val());
                var mv    = vlist.filter(function (v) { return v.id === cid; })[0];
                if (mv && mv.title.toLowerCase().indexOf('personalized') !== -1) {
                    // Personalize Now: enabled when required scents are selected
                    if (requiredScent1 && !selectedScent1) return false;
                    if (requiredScent2 && !selectedScent2) return false;
                    return true;
                }
            }
        } catch (e) {}
        return true;
    }

    function _validateATC() {
        var ok = _canPurchase();
        _atcBtn().prop('disabled', !ok);
        $('.custom-buy-button .shopify-payment-button__button').prop('disabled', !ok);
        _setAtcLabel(_atcLabel());
    }

    function _atcLabel() {
        if (_isSelectionSoldOut()) return 'Sold Out';
        var mv = _getCurrentVariant();
        return (mv && mv.title.indexOf('100ml Personalized') !== -1) ? 'Personalize Now' : 'Add to cart';
    }

    function _setAtcLabel(text) {
        var $btn    = _atcBtn();
        var $textEl = $btn.find('.hidden.md\\:block').first();
        ($textEl.length ? $textEl : $btn.find('.btn-text')).text(text);
    }

    window._fusionValidateATC = _validateATC;
    document.addEventListener('productInfo:loaded', _validateATC);

    function _atcBtn() { return $('.fusion-product-container .product-form__submit'); }

    function _initATCGuard() {
        var btn = _atcBtn()[0];
        if (!btn) return;
        new MutationObserver(function () {
            if (!_canPurchase() && !btn.disabled) btn.disabled = true;
        }).observe(btn, { attributes: true, attributeFilter: ['disabled'] });
    }

    // ─────────────────────────────────────────────────────────
    // SIZE AVAILABILITY (sold-out handling)
    // A bottle size can be bought only if BOTH chosen perfumes have an
    // in-stock variant in that size. Per-variant stock comes from #scent-data.
    // ─────────────────────────────────────────────────────────
    var SIZE_PREFERENCE   = ['100ml', '50ml', '100ml Personalized'];
    var COMBO_UNAVAILABLE = 'This combination is currently unavailable. Please choose a different perfume.';
    var _noSizeAvailable  = false;   // chosen perfumes share no in-stock size
    var _refreshingSizes  = false;

    function _normSize(v) { return String(v || '').toLowerCase().replace(/\s+/g, ''); }

    // The fusion product's bottle-size radios. Matched by value ("50ml") rather than by
    // fieldset slug, because the option name is merchant-editable ("Choose Bottle Size").
    function _sizeInputs() {
        return $('.fusion-content variant-radios input[type="radio"]').filter(function () {
            return /\d\s*ml/i.test(this.value);
        });
    }

    function _sizeValues() {
        return _sizeInputs().map(function () { return this.value; }).get();
    }

    // True if the perfume has an in-stock variant in this size. A perfume with no
    // variant for the size at all counts as sold out in it.
    function _perfumeHasSize(perfume, size) {
        var want = _normSize(size);
        return (perfume.variants || []).some(function (v) {
            return v.available && (v.options || []).some(function (o) { return _normSize(o) === want; });
        });
    }

    /**
     * Availability of each bottle size for the chosen perfumes.
     * A perfume that hasn't been chosen yet (null) doesn't restrict anything.
     *
     * @param {Object|null} perfume1 - Perfume 1 entry from #scent-data, or null
     * @param {Object|null} perfume2 - Perfume 2 entry from #scent-data, or null
     * @param {string[]}   [sizes]   - size values; defaults to the sizes on the page
     * @returns {Object} size → { available, soldOutIn, note }, e.g.
     *   { '50ml': { available: false, soldOutIn: ['Perfume 2'], note: 'Perfume 2 (Rose Oud) sold out in 50ml' } }
     */
    function getAvailableSizes(perfume1, perfume2, sizes) {
        var picks  = [{ slot: 'Perfume 1', data: perfume1 }, { slot: 'Perfume 2', data: perfume2 }];
        var result = {};
        (sizes || _sizeValues()).forEach(function (size) {
            var out = picks.filter(function (p) { return p.data && !_perfumeHasSize(p.data, size); });
            result[size] = {
                available: out.length === 0,
                soldOutIn: out.map(function (p) { return p.slot; }),
                note: out.length
                    ? out.map(function (p) { return p.slot + ' (' + p.data.title + ')'; }).join(' and ') + ' sold out in ' + size
                    : ''
            };
        });
        return result;
    }
    window.fusionGetAvailableSizes = getAvailableSizes; // for QA from the browser console

    // Sold out in every bottle size the fusion offers — can't be picked at all
    function _isPerfumeSoldOut(perfume) {
        var sizes = _sizeValues();
        if (!sizes.length) return false;
        var status = getAvailableSizes(perfume, null, sizes);
        return sizes.every(function (s) { return !status[s].available; });
    }

    // The current pick can't be bought: no size left for this combination, the selected
    // size is sold out, or the fusion variant itself is sold out.
    function _isSelectionSoldOut() {
        if (_noSizeAvailable) return true;
        var checked = _sizeInputs().filter(':checked')[0];
        if (checked && checked.disabled) return true;
        var mv = _getCurrentVariant();
        return !!(mv && mv.available === false);
    }

    // Live message under the size buttons, shown when every size is hidden
    function _sizeStatus() {
        var $s = $('.fusion-content .fusion-size-status');
        if (!$s.length) {
            $s = $('<p class="fusion-size-status" role="status" aria-live="polite"></p>');
            _sizeInputs().first().closest('ul').after($s);
        }
        return $s;
    }

    // Sold-out sizes are hidden. The radio is also disabled so the auto-switch
    // and the ATC checks treat it as unavailable.
    function _setSizeState(input, soldOut) {
        input.disabled = soldOut;
        $(input).closest('li').toggleClass('fusion-size-hidden', soldOut);
    }

    // Switch target when the selected size sells out. Skips sizes the theme marks
    // .disabled (the fusion variant itself is sold out).
    function _preferredSize($inputs) {
        var order = SIZE_PREFERENCE.map(_normSize);
        function rank(el) { var i = order.indexOf(_normSize(el.value)); return i < 0 ? order.length : i; }
        return $inputs.get()
            .filter(function (el) { return !el.disabled && !$(el).hasClass('disabled'); })
            .sort(function (a, b) { return rank(a) - rank(b); })[0] || null;
    }

    /**
     * Re-evaluate every bottle size for the current perfumes: hide sold-out sizes,
     * move off a selected size that just sold out, then sync message, price and ATC.
     * Runs on load, after each perfume change, after reset and after the live stock check.
     */
    function _refreshSizeAvailability() {
        var $inputs = _sizeInputs();
        if (_refreshingSizes || !$inputs.length) return;
        _refreshingSizes = true;
        try {
            var status = getAvailableSizes(selectedScent1, selectedScent2, _sizeValues());
            $inputs.each(function () {
                _setSizeState(this, !status[this.value].available);
            });

            var checked = $inputs.filter(':checked')[0];
            if (!checked || checked.disabled) {
                if (checked) checked.checked = false;
                var next = _preferredSize($inputs);
                if (next) next.click(); // fires change → theme updates variant id + price
            }

            // Nothing left to select → leave every size deselected and explain why
            _noSizeAvailable = !!(selectedScent1 || selectedScent2) && !$inputs.filter(':checked').length;
            _sizeStatus().text(_noSizeAvailable ? COMBO_UNAVAILABLE : '');
            $('.fusion-content .product__price').toggleClass('fusion-price-unavailable', _noSizeAvailable);
        } finally {
            _refreshingSizes = false;
        }
        _validateATC();
    }

    // Re-apply after any picker change: the template's custom-liquid variant script
    // resets `disabled` on option inputs whenever the picker changes.
    document.addEventListener('change', function (e) {
        if (e.target.closest && e.target.closest('.fusion-content variant-radios')) _refreshSizeAvailability();
    });

    // ── Live stock re-check — inventory can change while the page is open ──
    function _fetchLiveVariants(perfume) {
        var root = ((window.theme && theme.routes && theme.routes.root_url) || '/').replace(/\/$/, '');
        return fetch(root + '/products/' + encodeURIComponent(perfume.handle) + '.js', { credentials: 'same-origin', cache: 'no-store' })
            .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
            .then(function (p) {
                var variants = (p.variants || []).map(function (v) {
                    return { id: v.id, options: v.options, available: v.available };
                });
                // The same perfume appears in both scent lists — update every copy
                ['scent1', 'scent2'].forEach(function (key) {
                    var src  = scentData[key] || [];
                    var cols = Array.isArray(src) ? src : (src.collections || []);
                    cols.forEach(function (col) {
                        (col.products || []).forEach(function (item) {
                            if (item.id == perfume.id) item.variants = variants;
                        });
                    });
                });
            });
    }

    // Resolves true only if the same size is still purchasable after refreshing stock.
    // If the request fails, the stock embedded in the page is used.
    function _verifyLiveStock() {
        var before = _sizeInputs().filter(':checked')[0];
        var sizeBefore = before ? before.value : null;
        var picks = [selectedScent1, selectedScent2].filter(function (p) { return p && p.handle; });
        return Promise.all(picks.map(_fetchLiveVariants))
            .catch(function (err) { console.warn('[Fusion] Live stock check failed — using page data', err); })
            .then(function () {
                _refreshSizeAvailability();
                var now = _sizeInputs().filter(':checked')[0];
                // If the size was switched, let the shopper see the new size and price first
                return _canPurchase() && !!now && now.value === sizeBefore;
            });
    }

    // ── ATC guard ──
    // Capture phase, so it runs before the theme's form handler and the Personalize Now
    // intercept: a sold-out combination can never reach the cart, whatever the button state.
    var _stockVerified  = false;
    var _verifyingStock = false;
    document.addEventListener('click', function (e) {
        var btn = e.target.closest && e.target.closest('.fusion-product-container .product-form__submit');
        if (!btn) return;
        if (_stockVerified) { _stockVerified = false; return; } // our own re-dispatched click
        e.preventDefault();
        e.stopImmediatePropagation();
        if (_verifyingStock) return;
        if (!_canPurchase()) { _validateATC(); return; }

        var bypass = _bypassPersonalizeIntercept; // set when clicked from the personalization popup
        _verifyingStock = true;
        btn.setAttribute('aria-busy', 'true');
        _verifyLiveStock()
            .catch(function (err) { console.warn('[Fusion] Stock check error', err); return false; })
            .then(function (ok) {
                _verifyingStock = false;
                btn.removeAttribute('aria-busy');
                if (!ok || btn.disabled) return;
                _stockVerified = true;
                _bypassPersonalizeIntercept = bypass;
                btn.click();
                _stockVerified = false;
                _bypassPersonalizeIntercept = false;
            });
    }, true);

    // Backstop for submits that bypass the button click (e.g. form.requestSubmit() from another script)
    document.addEventListener('submit', function (e) {
        if (!e.target.closest || !e.target.closest('.fusion-product-container')) return;
        if (_canPurchase()) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        _validateATC();
    }, true);

    // ─────────────────────────────────────────────────────────
    // SCENT MODAL
    // ─────────────────────────────────────────────────────────
    function _buildSlideHTML(item) {
        return '<div class="slide-item"><h4>PERFUME NOTES</h4><div class="notes-details">'
            + (item.topNote    ? '<img src="' + item.topNote    + '" alt="Top note">'     : '')
            + (item.middleNote ? '<img src="' + item.middleNote + '" alt="Middle notes">' : '')
            + (item.baseNote   ? '<img src="' + item.baseNote   + '" alt="Base notes">'   : '')
            + '</div></div>'
            + '<div class="slide-item"><h4>INTENSITY</h4>'
            +   '<img src="' + (item.intensity   || '') + '" alt="Intensity"   class="intensity_img">'
            + '</div>'
            + '<div class="slide-item"><h4>PERSONALITY</h4>'
            +   '<img src="' + (item.personality || '') + '" alt="Personality" class="personality_img ' + (item.theme_mode || '') + '">'
            + '</div>';
    }

    var _scentBeforeModal = null; // applied perfume to restore if the shopper cancels

    function _openModal(scentKey) {
        activeScentKey = scentKey;
        _scentBeforeModal = (scentKey === 'scent1') ? selectedScent1 : selectedScent2;
        $('.modal-apply').prop('disabled', true);
        $('.scent-modal-details').removeClass('open');
        var $tabs = $('.collection-tabs').empty();
        (scentData[scentKey] || []).forEach(function (col, i) {
            $tabs.append(
                '<button class="tab-btn uppercase' + (i === 0 ? ' active' : '') +
                '" data-index="' + i + '">' + col.customTitle || col.title+ '</button>'
            );
        });
        _loadModalProducts(0);
        $('.scent-modal, .scent-modal-overlay').addClass('open');
        $('body').css('overflow', 'hidden');
    }

    function _loadModalProducts(idx) {
    var src         = scentData[activeScentKey];
    var collections = Array.isArray(src) ? src : src.collections;
    currentProducts = collections[idx].products;
    var $grid = $('.modal-products-grid').empty();

    // Block the product already chosen in the OTHER slot
    var otherSelected = (activeScentKey === 'scent1') ? selectedScent2 : selectedScent1;
    var blockedId     = otherSelected ? otherSelected.id : null;

    currentProducts.forEach(function (item) {
        var isBlocked = blockedId && (item.id == blockedId);
        // Sold out in every bottle size → not selectable
        var isSoldOut = !isBlocked && _isPerfumeSoldOut(item);
        $grid.append(
            '<div class="fusion-product-card' + (isBlocked ? ' fusion-card-blocked' : '') + (isSoldOut ? ' fusion-card-soldout' : '') + '"' +
            ' data-product-id="' + item.id + '"' + (isSoldOut ? ' aria-disabled="true"' : '') + '>' +
            '<img src="' + item.image + '">' +
            '<p class="product-title">' + item.title + '</p>' +
            (isBlocked
                ? '<div class="fusion-blocked-overlay"><span>Already Selected</span></div>'
                : isSoldOut
                    ? '<div class="fusion-blocked-overlay"><span>Sold Out</span></div>'
                    : '') +
            '</div>'
        );
    });
}

    $('.scent-btn').on('click', function () {
        _openModal($(this).data('fusion-scent') === 'option1' ? 'scent1' : 'scent2');
    });

    $(document).on('click', '.modal-products-grid .fusion-product-card', function () {
        if ($(this).is('.fusion-card-blocked, .fusion-card-soldout')) return;
        $('.fusion-product-card').removeClass('selected');
        var id   = $(this).data('product-id');
        var data = currentProducts.filter(function (p) { return p.id == id; })[0];
        if (!data) return;

        // Store selection immediately so detail modal apply knows what's selected
        if (activeScentKey === 'scent1') selectedScent1 = data;
        if (activeScentKey === 'scent2') selectedScent2 = data;

        var $det = $('.scent-modal-details');
        $det.find('.banner-container').empty().append(
            '<img src="' + data.bannerImage + '" loading="lazy" alt="">'
        );
        $det.find('.product-details .product-title').text(data.title);
        var $slide = $det.find('.details-slide');
        if ($slide.hasClass('slick-initialized')) $slide.slick('unslick');
        $slide.empty().html(_buildSlideHTML(data));
        $slide.slick({
            dots: true, infinite: true, slidesToShow: 1, slidesToScroll: 1, arrows: true,
            prevArrow: window.slickPrevArrow, nextArrow: window.slickNextArrow
        });
        $('.scent-modal-details .modal-apply').prop('disabled', false);
        $('.scent-modal').removeClass('open');
        $('.scent-modal-details').addClass('open');
    });

    $(document).on('click', '.collection-tabs .tab-btn', function () {
        $('.tab-btn').removeClass('active'); $(this).addClass('active');
        _loadModalProducts(Number($(this).data('index')));
    });

    $(document).on('click', '.scent-modal-product-list .modal-cancel', function () {
        $('.scent-modal, .scent-modal-overlay').removeClass('open');
        $('body').css('overflow', '');
    });

    $(document).on('click', '.scent-modal-details .modal-cancel', function () {
        // User cancelled from detail view — revert to the perfume applied before the modal opened
        if (activeScentKey === 'scent1') selectedScent1 = _scentBeforeModal;
        if (activeScentKey === 'scent2') selectedScent2 = _scentBeforeModal;
        $('.scent-modal-details .banner-container').empty();
        $('.scent-modal-details').removeClass('open');
        $('.scent-modal').addClass('open');
    });

    // Apply button — confirm selection and update bottle slot image
    $('.modal-apply').on('click', function () {
        if (activeScentKey === 'scent1' && selectedScent1) {
            var $b1 = $('.scent-btn[data-fusion-scent="option1"]');
            $b1.find('.scent-btn-label').hide();
            $b1.find('.scent-btn-preview').removeClass('hidden');
            $b1.find('.scent-btn-image').attr('src', selectedScent1.bannerImage || '');
            $b1.find('.scent-btn-title').text(selectedScent1.title || '');
            $b1.addClass('selected');
        }

        if (activeScentKey === 'scent2' && selectedScent2) {
            var $b2 = $('.scent-btn[data-fusion-scent="option2"]');
            $b2.find('.scent-btn-label').hide();
            $b2.find('.scent-btn-preview').removeClass('hidden');
            $b2.find('.scent-btn-image').attr('src', selectedScent2.bannerImage || '');
            $b2.find('.scent-btn-title').text(selectedScent2.title || '');
            $b2.addClass('selected');
        }

        // Update only the relevant bottle slot
        _updateProductImg();
        _updateConcentrationLabels();
        // Before _rebuildProps — may switch the size, which changes the variant
        _refreshSizeAvailability();
        _rebuildProps();
        _validateATC();

        $('.scent-modal-details .banner-container').empty();
        $('.scent-modal-details, .scent-modal, .scent-modal-overlay').removeClass('open');
        $('body').css('overflow', '');
    });

    // ─────────────────────────────────────────────────────────
    // CONCENTRATION SLIDER
    // ─────────────────────────────────────────────────────────
    function _syncConc(s1, s2) {
        $('form[action="/cart/add"]').each(function () {
            var $f = $(this);
            $f.find('input[name="properties[Perfume 1]"]').remove();
            $f.find('input[name="properties[Perfume 2]"]').remove();
            if (selectedScent1)
                $('<input>', { type: 'hidden', name: 'properties[Perfume 1]',
                    value:  selectedScent1.title + ' | ' + s1+ '%'
                }).appendTo($f);
            if (selectedScent2)
                $('<input>', { type: 'hidden', name: 'properties[Perfume 2]',
                    value: selectedScent2.title + ' | ' + s2+ '%'
                }).appendTo($f);
        });
    }

    $(document).on('input change', '.fusion-concentration-block .fusion-concentration-slider', function () {
        var $s  = $(this);
        var val = Number($s.val());
        var min = Number($s.attr('min')) || 0;
        var max = Number($s.attr('max')) || 100;
        var s1  = val, s2 = max - val + min;
        var pct = ((val - min) / (max - min)) * 100;
        var $p  = $s.closest('.fusion-concentration-block');
        $p.find('.option1-percent .val').text(s1);
        $p.find('.option2-percent .val').text(s2);
        $p.find('.scent1-hidden').val(s1);
        $p.find('.scent2-hidden').val(s2);
        _syncConc(s1, s2);
        $s.css('background', 'linear-gradient(to right,#000 ' + pct + '%,#e5e5e5 ' + pct + '%)');
    });

    $('.fusion-concentration-slider').trigger('input');

    $(document).on('click', '.shopify-payment-button__button', function () {
        _rebuildProps();
        var $s = $('.fusion-concentration-block .fusion-concentration-slider');
        if (!$s.length) return;
        var val = Number($s.val()), min = Number($s.attr('min')) || 0, max = Number($s.attr('max')) || 100;
        _syncConc(val, max - val + min);
    });

    // ─────────────────────────────────────────────────────────
    // VARIANT & ENGRAVING
    // ─────────────────────────────────────────────────────────
    function _fs(slug)  { return $('fieldset[data-option-slug="' + slug + '"]'); }
    function _cv(slug)  { return _fs(slug).find('input:checked').val(); }
    function _pf(slug)  { _fs(slug).find('input:not(:disabled):visible').first().trigger('click'); }
    function _isGift()  { var v = _cv('how-would-you-like-to-buy'); return v && v.toLowerCase() === 'gift'; }

    function _clearEngraving() {
        var $b = $('.fusion-engraving-block');
        if ($b.hasClass('hidden')) return;
        $b.find('.engraving-textarea').val('');
        $b.find('.engraving-style-input').val('');
        $b.find('.engraving-style-btn').removeClass('selected').first().addClass('selected');
    }

    function _syncEngStyle() {
        var $b = $('.fusion-engraving-block');
        if ($b.hasClass('hidden')) return;
        var text = $b.find('.engraving-textarea').val().trim();
        var $si  = $b.find('.engraving-style-input');
        if (!text) { $si.val(''); return; }
        var $sel = $b.find('.engraving-style-btn.selected');
        $si.val($sel.css('--font-family') || $sel.text().trim());
    }

    function _updateEngVis() {
        var show = _cv('size') === '100ml' && _isGift();
        var $b   = $('.fusion-engraving-block');
        if (!show) _clearEngraving();
        $b.toggleClass('hidden', !show);
        requestAnimationFrame(_validateATC);
    }

    $(document).on('click', '.buy-option-buttons .fusion-btn', function () {
        $('.buy-option-buttons .fusion-btn').removeClass('selected');
        $(this).addClass('selected');
        var type = $(this).data('type');
        var $sf  = _fs('size'), $pf = _fs('personalized');
        if (type === 'gift') {
            $sf.find('input[value="50ml"]').closest('li').addClass('hidden');
            var $s100 = $sf.find('input[value="100ml"]');
            if ($s100.length && !$s100.is(':disabled')) { if (!$s100.is(':checked')) $s100.trigger('click'); } else _pf('size');
            var $pNo = $pf.find('input[value="No"]');
            $pNo.closest('li').addClass('hidden');
            if ($pNo.is(':checked')) $pf.find('input[value="Yes"]').trigger('click');
        } else {
            $sf.find('input[value="50ml"]').closest('li').removeClass('hidden');
            $pf.find('input[value="No"]').closest('li').removeClass('hidden');
        }
        requestAnimationFrame(_updateEngVis);
    });

    $(document).on('change',
        'fieldset[data-option-slug="size"] input,' +
        'fieldset[data-option-slug="how-would-you-like-to-buy"] input',
        _updateEngVis
    );
    $(document).on('input', '.engraving-textarea', function () { _syncEngStyle(); _validateATC(); });
    $(document).on('click', '.engraving-style-btn', function () {
        $('.engraving-style-btn').removeClass('selected'); $(this).addClass('selected'); _syncEngStyle();
    });

    _updateEngVis();
    _initATCGuard();
    _refreshSizeAvailability(); // initial state — no-op until a perfume is chosen

    // ── Set initial button state based on default variant ────────
    (function _initButtonText() {
        var mv = _getCurrentVariant();
        if (mv) _swapButtons(mv.title.indexOf('100ml Personalized') !== -1);
    })();

    // ── Intercept ATC button when in Personalize Now mode ───────
    $(document).on('click', '.fusion-product-container .product-form__submit', function (e) {
        // If bypass flag is set — real ATC click from popup, let it through
        if (_bypassPersonalizeIntercept) return;
        var mv = _getCurrentVariant();
        if (!mv || mv.title.indexOf('100ml Personalized') === -1) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        _openPopup(mv.id);
    });

    // ─────────────────────────────────────────────────────────
    // RESET
    // ─────────────────────────────────────────────────────────
    $(document).on('submit', '.fusion-product-container form', function () { setTimeout(_reset, 1000); });
    function _resetVariantToDefault() {
    var $sizeFieldset = $('fieldset[data-option-slug="size"]');
    if (!$sizeFieldset.length) return;

    var $defaultOption = $sizeFieldset.find('input[value="50ml"]:not(:disabled)').first();
    if (!$defaultOption.length) return;

    // ✅ Step 1: click radio (UI update)
    $defaultOption.prop('checked', true).trigger('click');

    // ✅ Step 2: force Shopify variant change properly
    setTimeout(function () {
        $defaultOption[0].dispatchEvent(new Event('change', { bubbles: true }));

        // ✅ Step 3: manually sync variant ID (VERY IMPORTANT)
        var $form = $('form[action="/cart/add"]');
        var variantDataScript = document.querySelector(
            'variant-radios script[type="application/json"], variant-selects script[type="application/json"]'
        );

        if (variantDataScript) {
            try {
                var variants = JSON.parse(variantDataScript.textContent);

                // find 50ml variant
                var match = variants.find(function (v) {
                    return v.title.toLowerCase().includes('50ml');
                });

                if (match) {
                    $form.find('input[name="id"]').val(match.id);
                }
            } catch (e) {}
        }

    }, 150);
}
function _reset() {
    selectedScent1 = selectedScent2 = activeScentKey = null;
    _updateConcentrationLabels();
    _refreshSizeAvailability(); // re-enable every size before picking the default
    _resetVariantToDefault();

    $('form[action="/cart/add"]').each(function () {
        var $f = $(this);
        $f.find([
            'input[name="properties[Perfume 1]"]',
            'input[name="properties[Perfume 2]"]',
            'input[name="properties[scent1_concentration]"]',
            'input[name="properties[scent2_concentration]"]',
            // ✅ ADD THESE — were never cleaned up
            'input[name="properties[Engraving Text]"]',
            'input[name="properties[Font Style]"]',
            'input[name="properties[Gift Wrap]"]',
            'input[name="properties[Personal Note Text]"]'
        ].join(',')).remove();
        $f.find('input.scent1-hidden, input.scent2-hidden').attr('name', '').val('');
    });

    // ✅ ADD — clear popup engraving state too
    $inp().val('');
    $chars().text('0');
    fusionSelectedFont = 'Classic';
    $('.myop-font-option').removeClass('selected').filter('[data-font="Classic"]').addClass('selected');
    $('#myop-gift-wrap, #myop-personal-note').prop('checked', false);
    $('.myop-note-field').hide();
    $('#myop-note-text').val('');

    $('.scent-btn').each(function () {
        $(this).removeClass('selected')
            .find('.scent-btn-preview').addClass('hidden').end()
            .find('.scent-btn-label').show().end()
            .find('.scent-btn-image').attr('src', '').end()
            .find('.scent-btn-title').text('');
    });
    $('.fusion-concentration-slider').val(50).trigger('input');
    _setBottleImage('fusion-slot-1', 'fusion-bottle-img-1', null);
    _setBottleImage('fusion-slot-2', 'fusion-bottle-img-2', null);
    fusionPersonalizedApplied = false;
    _clearEngraving();
    _atcBtn().prop('disabled', true);
    $('.custom-buy-button .shopify-payment-button__button').prop('disabled', true);
    _validateATC();
}

    // ─────────────────────────────────────────────────────────
    // INFINITEOPTIONS OBSERVER
    // ─────────────────────────────────────────────────────────
    var _ioObs = new MutationObserver(function (_, obs) {
        var c = document.getElementById('infiniteoptions-container');
        if (!c) return;
        var hasText  = c.querySelectorAll('input[type=text]').length > 0;
        var hasRadio = c.querySelectorAll("input[name='properties[Font Style]']").length > 0;
        if (hasText && hasRadio) {
            $('#infiniteoptions-container input[type=text]').val('');
            $('#infiniteoptions-container input[name=\'properties[Font Style]\']').prop('checked', false);
            obs.disconnect();
        }
    });
    _ioObs.observe(document.body, { childList: true, subtree: true });

    // ─────────────────────────────────────────────────────────
    // PERSONALIZATION POPUP
    // ─────────────────────────────────────────────────────────
    var fusionBgImage             = null;
    var fusionSelectedFont        = 'Classic';
    var fusionPersonalizedApplied = false;

    function $inp()  { return $('#fusion-engraving-input'); }
    function $chars(){ return $('#fusion-char-used'); }

    function _openPopup(variantId) {
        var $popup = $('#fusion-product-popup');
        if (!$popup.length) return;
        $inp().val(''); $chars().text('0');

     // AFTER
        $('.myop-font-option').removeClass('selected').filter('[data-font="Classic"]').addClass('selected');
        fusionSelectedFont = 'Classic';

        // Preload all fonts so first-click renders correctly
        if (document.fonts && document.fonts.load) {
            Promise.all([
                    document.fonts.load('18px "Classic"'),
                    document.fonts.load('18px "Elegant"'),
                    document.fonts.load('18px "Playful"'),
                    document.fonts.load('18px "Cursive"'),
                    document.fonts.load('18px "Roman"'),
                    document.fonts.load('18px "Sleek"')
            ]).then(function () { _drawEngrCanvas(); });
        }
        $('#myop-gift-wrap, #myop-personal-note, #fusion-gift-wrap, #fusion-personal-note').prop('checked', false);
        $('.myop-note-field').hide(); $('#myop-note-text').val('');
        _updateApplyBtn();
        $popup.removeClass('hidden').show();
        $('body').addClass('no-scroll');
        _initEngrCanvas(variantId);
        var ioInt = setInterval(function () {
            var $s = $('#infiniteoptions-container');
            if ($s.length && $.trim($s.html()) !== '') {
                clearInterval(ioInt);
                if (!$('#fusionEmptyDiv #infiniteoptions-container').length) {
                    $('#fusionEmptyDiv').append($s[0].outerHTML);
                    $('#fusionEmptyDiv #infiniteoptions-container input[type=text]').attr('maxlength', 12);
                }
            }
        }, 300);
    }

    // ── Swap button text on existing ATC button ─────────────────
    var _isPersonalizedVariant = false;
    function _swapButtons(isPersonalized) {
        _isPersonalizedVariant = isPersonalized;
        // _validateATC sets the label: "Personalize Now" / "Add to cart" / "Sold Out"
        _validateATC();
    }

    // ── Helper: check current variant from form input (always accurate) ──
    function _getCurrentVariant() {
        var cid = Number($('form[action="/cart/add"] input[name="id"]').val());
        if (!cid) return null;
        try {
            var vde = document.querySelector(
                'variant-radios script[type="application/json"],' +
                'variant-selects script[type="application/json"]'
            );
            if (!vde) return null;
            var variants = JSON.parse(vde.textContent);
            return variants.filter(function (v) { return v.id === cid; })[0] || null;
        } catch (e) { return null; }
    }

    // ── Sync button text — exposed globally so toggleBuyButton patch can call it ──
    function _syncButtonText() {
        var mv = _getCurrentVariant();
        if (!mv) return;
        if (mv.title.indexOf('100ml Personalized') !== -1) {
            _swapButtons(true);
        } else {
            _swapButtons(false);
        }
    }
    window._fusionSyncButtonText = _syncButtonText;

    // Variant change — use variant:change event fired by Shopify AFTER form input is updated
document.addEventListener('variant:change', function () {
    var mv = _getCurrentVariant();
    if (!mv) return;
    if (mv.title.indexOf('100ml Personalized') !== -1) {
        _swapButtons(true);
    } else {
        _swapButtons(false);
        $('#fusion-product-popup').addClass('hidden').hide();
        $('body').removeClass('no-scroll');
        fusionPersonalizedApplied = false;

        $('form[action="/cart/add"]').find([
            'input[name="properties[Engraving Text]"]',
            'input[name="properties[Font Style]"]',
            'input[name="properties[Gift Wrap]"]',
            'input[name="properties[Personal Note Text]"]'
        ].join(',')).remove();

        // ✅ ADD — clear the popup fields so they don't re-appear next time
        $inp().val('');
        $chars().text('0');
        fusionSelectedFont = 'Classic';
        $('.myop-font-option').removeClass('selected').filter('[data-font="Classic"]').addClass('selected');
        $('#myop-gift-wrap, #myop-personal-note').prop('checked', false);
        $('.myop-note-field').hide();
        $('#myop-note-text').val('');

        $('#fusion-slot-1').removeClass('is-personalized');
        _updateProductImg();
    }
});

    // Fallback: also listen on click with longer delay in case variant:change doesn't fire
    document.addEventListener('click', function (e) {
        if (!e.target.matches('variant-radios input[type="radio"]')) return;
        setTimeout(_syncButtonText, 300);
    });

    // ── Engraving canvas ──────────────────────────────────────
    function _initEngrCanvas(variantId) {
        var canvas = document.getElementById('fusion-engravingCanvas');
        if (!canvas) return;
        canvas.width = 450; canvas.height = 450;
        var ctx = canvas.getContext('2d');
        fusionBgImage = new Image();
        fusionBgImage.crossOrigin = 'anonymous';
        fusionBgImage.onload  = _drawEngrCanvas;
        fusionBgImage.onerror = function () { ctx.fillStyle = '#1a1a1a'; ctx.fillRect(0, 0, 450, 450); };

        // Use variant image map or placeholder 1 as base image for engraving preview
        var imgMap = window.fusionVariantImageMap || {};
        var imgUrl = imgMap[Number(variantId)] || placeholder1 || '';
        if (imgUrl) fusionBgImage.src = imgUrl;
        else { ctx.fillStyle = '#1a1a1a'; ctx.fillRect(0, 0, 450, 450); }
    }

    function _drawEngrCanvas() {
        var canvas = document.getElementById('fusion-engravingCanvas');
        if (!canvas) return;

        var ctx = canvas.getContext('2d');

        var fontSize, xRange = 0, textWidth = 90;

        if (fusionSelectedFont === 'Classic') {
            fontSize = 14; xRange = 227; textWidth = 90;
        } else if (fusionSelectedFont === 'Elegant') {
            fontSize = 16; xRange = 230; textWidth = 90;
        } else if (fusionSelectedFont === 'Playful') {
            fontSize = 12; xRange = 227; textWidth = 90;
        }else if (fusionSelectedFont === 'Cursive') {
            fontSize = 18; xRange = 225; textWidth = 95; // script font → smaller
        } 
        else if (fusionSelectedFont === 'Roman') {
            fontSize = 12; xRange = 227; textWidth = 90;
        } 
        else if (fusionSelectedFont === 'Sleek') {
            fontSize = 18; xRange = 227; textWidth = 90;
        }

        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.font = fontSize + "px '" + fusionSelectedFont + "'";

        if (fusionBgImage && fusionBgImage.complete && fusionBgImage.naturalWidth) {
            ctx.drawImage(fusionBgImage, 0, 0, canvas.width, canvas.height);
        } else {
            ctx.fillStyle = '#1a1a1a'; ctx.fillRect(0, 0, canvas.width, canvas.height);
        }

        var text = $inp().val().trim();
        if (!text) return;

        ctx.shadowColor = 'transparent';
        ctx.shadowBlur = 0;
        ctx.shadowOffsetX = 0;
        ctx.shadowOffsetY = 0;
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';

        var currentFontSize = fontSize;

        var NoOfLines = _wrapTextFusion(ctx, text, xRange, 237, textWidth, 20);

        if (fusionSelectedFont === 'Elegant' &&
            (text.charAt(0) === 'j' || text.charAt(0) === 'J' || text.charAt(0) === 'f')) {
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            if (fusionBgImage && fusionBgImage.complete && fusionBgImage.naturalWidth) {
                ctx.drawImage(fusionBgImage, 0, 0, canvas.width, canvas.height);
            }
            NoOfLines = _wrapTextFusion(ctx, text, 232, 235, 75, 20);
        }

        if (NoOfLines > 2) {
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            if (fusionBgImage && fusionBgImage.complete && fusionBgImage.naturalWidth) {
                ctx.drawImage(fusionBgImage, 0, 0, canvas.width, canvas.height);
            }
            currentFontSize -= 2;
            ctx.font = fontSize + "px '" + fusionSelectedFont + "'";
            _wrapTextFusion(ctx, text, xRange, 235, textWidth, 20);
        }
    }
    function _wrapTextFusion(ctx, text, x, y, maxWidth, lineHeight) {
        var lines = [];
        var words = text.split(' ');
        var maxchar = 10;

        for (var wi = 0; wi < words.length; wi++) {
            var word = words[wi];
            var currentLine = lines.pop() || '';
            var testLine = currentLine ? currentLine + ' ' + word : word;
            var testWidth = ctx.measureText(testLine).width;

            if (testWidth <= maxWidth && testLine.length <= maxchar) {
                lines.push(testLine);
            } else {
                if (currentLine) lines.push(currentLine);
                if (ctx.measureText(word).width <= maxWidth && word.length <= maxchar) {
                    lines.push(word);
                } else {
                    var subLine = '';
                    for (var ci = 0; ci < word.length; ci++) {
                        var testSubLine = subLine + word[ci];
                        if (ctx.measureText(testSubLine).width > maxWidth || testSubLine.length > maxchar) {
                            lines.push(subLine);
                            subLine = word[ci];
                        } else {
                            subLine = testSubLine;
                        }
                    }
                    if (subLine) lines.push(subLine);
                }
            }
        }

        // if (lines.length > 1) y = y - (lines.length * 7);
           if (lines.length > 1) y = y - ((lines.length - 1) * lineHeight / 2);
        for (var li = 0; li < lines.length; li++) {
            ctx.fillText(lines[li], x, y + li * lineHeight);
        }

        return lines.length;
    }

    function _syncToIO() {
        var text = $inp().val();
        $('#fusionEmptyDiv #infiniteoptions-container input[type=text]').val(text);
        var $r = $('#fusionEmptyDiv #infiniteoptions-container input[type=radio]');
        $r.prop('checked', false);
        $r.filter('[value="' + fusionSelectedFont + '"]').prop('checked', true).trigger('change');
    }

    function _updateApplyBtn() {
        var ok = !!($inp().val().trim() && fusionSelectedFont);
        $('#fusion-product-popup .myop-modal-apply').prop('disabled', !ok);
    }

    // Add to cart from popup — rebuild props then click the real ATC button
    // This lets the theme handle side cart drawer exactly like 50ml/100ml
    var _bypassPersonalizeIntercept = false;

    $(document).on('click', '#fusion-product-popup .myop-modal-apply', function () {
        fusionPersonalizedApplied = true;
        _rebuildProps();

        // Close popup
        $('#fusion-product-popup').addClass('hidden').hide();
        $('body').removeClass('no-scroll');

        // Click the real ATC button — bypass flag prevents our intercept from re-opening popup
        _bypassPersonalizeIntercept = true;
        _atcBtn()[0].click();
        setTimeout(function () { _bypassPersonalizeIntercept = false; }, 500);
    });

    $(document).on('input', '#fusion-engraving-input', function () {
        var v = $(this).val();
        if (v.length > 12) { v = v.slice(0, 12); $(this).val(v); }
        $chars().text(v.length);
        _syncToIO(); _updateApplyBtn(); _drawEngrCanvas();
    });

    $(document).on('change', '#myop-personal-note', function () {
        $('.myop-note-field').toggle($(this).is(':checked'));
        if (!$(this).is(':checked')) $('#myop-note-text').val('');
    });

    // AFTER
    $(document).on('click', '#fusion-product-popup .myop-font-option', function () {
        $('.myop-font-option').removeClass('selected');
        $(this).addClass('selected');
        fusionSelectedFont = $(this).data('font') || 'Classic';
        _syncToIO(); _drawEngrCanvas(); _updateApplyBtn();
    });

    $(document).on('change', '#fusion-gift-wrap, #fusion-personal-note', function () {
        $('.myop-note-field').toggle($('#fusion-personal-note').is(':checked'));
        if (!$('#fusion-personal-note').is(':checked')) $('#myop-note-text').val('');
    });

    $(document).on('click', '#fusion-product-popup .myop-modal-cancel', function () {
        $('#fusion-product-popup').addClass('hidden').fadeOut(200);
        $('body').removeClass('no-scroll');
        $inp().val(''); $chars().text('0');
        $('form[action="/cart/add"]').find([
            'input[name="properties[Gift Wrap]"]',
            'input[name="properties[Personal Note]"]',
            'input[name="properties[Personal Note Text]"]'
        ].join(',')).remove();
    });

    // ─────────────────────────────────────────────────────────
    // REBUILD FORM PROPERTIES
    // ─────────────────────────────────────────────────────────
    function _rebuildProps() {
        var $form = $('form[action="/cart/add"]');
        $form.find([
            'input[name^="properties[scent"]',
            'input[name="properties[scent1_concentration]"]',
            'input[name="properties[scent2_concentration]"]',
            'input[name="properties[Perfume 1]"]',
            'input[name="properties[Perfume 2]"]',
            'input[name="properties[Engraving Text]"]',
            'input[name="properties[Font Style]"]',
            'input[name="properties[Gift Wrap]"]',
            'input[name="properties[Personal Note Text]"]'
        ].join(',')).remove();
        $form.find('input.scent1-hidden, input.scent2-hidden').attr('name', '').val('');

        var $sl  = $('.fusion-concentration-slider');
        var s1c  = $sl.length ? Number($sl.val())              : 50;
        var slMn = $sl.length ? (Number($sl.attr('min')) || 0) : 0;
        var slMx = $sl.length ? (Number($sl.attr('max')) || 100) : 100;
        var s2c  = slMx - s1c + slMn;

        if (selectedScent1) $('<input>', { type: 'hidden', name: 'properties[Perfume 1]',
            value:selectedScent1.title + ' | ' + s1c + '%' }).appendTo($form);
        if (selectedScent2) $('<input>', { type: 'hidden', name: 'properties[Perfume 2]',
            value:selectedScent2.title + ' | ' + s2c + '%' }).appendTo($form);

        var isPersonalized = false;
        try {
            var vsc  = document.querySelector(
                'variant-radios script[type="application/json"],' +
                'variant-selects script[type="application/json"]'
            );
            if (vsc) {
                var vlist = JSON.parse(vsc.textContent);
                var cid   = Number($('form[action="/cart/add"] input[name="id"]').val());
                var mv    = vlist.filter(function (v) { return v.id === cid; })[0];
                if (mv) isPersonalized = mv.title.toLowerCase().indexOf('personalized') !== -1;
            }
        } catch (e) {}

        if (isPersonalized) {
            var et = $inp().val().trim();
            if (et) {
                $('<input>', { type: 'hidden', name: 'properties[Engraving Text]', value: et }).appendTo($form);
                $('<input>', { type: 'hidden', name: 'properties[Font Style]',     value: fusionSelectedFont }).appendTo($form);
            }
            if ($('#myop-gift-wrap').is(':checked'))
                $('<input>', { type: 'hidden', name: 'properties[Gift Wrap]', value: 'Yes' }).appendTo($form);
            if ($('#myop-personal-note').is(':checked')) {
                var nt = $('#myop-note-text').val().trim();
                if (nt) $('<input>', { type: 'hidden', name: 'properties[Personal Note Text]', value: nt }).appendTo($form);
            }
        }
    }

}); // end document.ready